import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  export(e) {
    e.preventDefault();
    let searchData = filtersFormData($(".account-receivables-filters-form"));
    let url = `${this.data.get("url")}?`;

    Object.keys(searchData).forEach(
      key => (url += `&${key}=${searchData[key]}`)
    );

    window.location.href = url;
  }
}
